<p class="text-center">
    Please wait {{ timer | date: 'mm:ss' }} before you can proceed.
</p>
